import { getWebInstrumentations, initializeFaro } from "@grafana/faro-react";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";
import { config } from "./config/config";

export const faro = config.faroUrl ? initializeFaro({
  url: config.faroUrl,
  app: {
    name: "portal",
    version: "1.0.0",
  },
  instrumentations: [...getWebInstrumentations(), new TracingInstrumentation()],
}) : null;
